import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function StartedColumnIcon(props: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon {...props} height="16" viewBoxDimensions="0 0 16 16" width="16">
      <path
        clipRule="evenodd"
        d="M8 0C5.87827 0 3.84344 0.842853 2.34315 2.34315C0.842853 3.84344 0 5.87827 0 8C0 10.1217 0.842853 12.1565 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16C10.1217 16 12.1565 15.1571 13.6569 13.6569C15.1571 12.1565 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1565 0.842853 10.1217 0 8 0ZM8 3H7.66667V13H8C8.6566 13 9.3068 12.8707 9.9134 12.6194C10.5201 12.3681 11.0713 11.9998 11.5355 11.5355C11.9998 11.0713 12.3681 10.5201 12.6194 9.9134C12.8707 9.3068 13 8.6566 13 8C13 7.3434 12.8707 6.6932 12.6194 6.08658C12.3681 5.47995 11.9998 4.92876 11.5355 4.46447C11.0713 4.00017 10.5201 3.63187 9.9134 3.3806C9.3068 3.12933 8.6566 3 8 3Z"
        fill="#E87A14"
        fillRule="evenodd"
      />
    </SimpleIcon>
  );
}
